module.exports = __webpack_public_path__ + "static/media/select.626a63e4.svg";